import { Button, Col, Icon, Layout, Menu, Popover, Row } from 'antd';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import Responsive from 'react-responsive';
import { Link } from 'react-router-dom';
import LogoSvg from '../components/icons/Logo';
import toCamelCase from '../utils/toCamelCase';

const { SubMenu } = Menu;
const { Header } = Layout;

const styles = () => ({
  root: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    height: 'auto',
    position: 'fixed',
    width: '100%',
    left: 0,
    top: 0,
    right: 0,
    zIndex: 1000,
    '@media (max-width: 992px)': {
      '& #headerMenu': {
        alignSelf: 'center',
      },
    },
  },
  logo: {
    padding: '1em 0.5em',
  },
  logoTitle: {
    color: '#486F71',
  },
  menu: {
    float: 'right',
  },
  logoLink: {
    display: 'block',
    '&:link': {
      'text-decoration': 'none',
    },
  },
  popoverMenu: {
    '& .ant-popover-inner-content': {
      padding: 0,
    },
    position: 'relative',
    right: 0,
    width: '70%',
  },
  button: {
    cursor: 'pointer',
    background: '#FAFAFA',
    borderColor: '#FAFAFA',
    color: 'rgba(42, 44, 46, 0.72)',
    '&:hover': {
      color: 'rgba(42, 44, 46, 0.72)',
      borderColor: '#FAFAFA',
      background: '#FAFAFA',
    },
  },
  menuItem: {
    '&:active': {
      backgroundColor: '#B68962',
      color: '#FAFAFA',
    },
  },
});

const compétences = [
  'Fonction publique',
  'Urbanisme et construction',
  'Marché public',
  'Contentieux des aides sociales',
  'Responsabilité médicale',
];

const MenuDesktop = (props) => <Responsive {...props} minWidth={992} />;
const MenuSider = (props) => <Responsive {...props} maxWidth={991} />;

class HeaderTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: window.location.href.split('/').slice(-1)[0] || 'accueil',
      menuVisible: false,
    };
  }
  componentDidUpdate(nextProps, prevState) {
    const nextState = window.location.href.split('/').slice(-1)[0] || 'accueil';
    if (nextState !== prevState.current) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        current: nextState || 'accueil',
      });
    }
  }
  onMenuVisibleChange = (visible) => {
    this.setState({
      menuVisible: visible,
    });
  };
  handleShowMenu = () => {
    this.setState({
      menuVisible: true,
    });
  };

  handleHideMenu = () => {
    this.setState({
      menuVisible: false,
    });
  };
  handleClick = (e) => {
    this.setState({ current: e.key, menuVisible: false });
  };

  render() {
    const { classes } = this.props;
    const { menuVisible } = this.state;
    const logo = (
      <Row className={classes.logo} align="middle" justify="center" gutter={12}>
        <LogoSvg />
      </Row>
    );

    const menuContent = [
      <Menu.Item key="accueil" className={classes.menuItem}>
        <Link href="/" to="/">
          Accueil
        </Link>
      </Menu.Item>,
      <SubMenu key="competences" title={<span>Compétences</span>}>
        {compétences.map((competence) => (
          <Menu.Item key={toCamelCase(competence)}>
            <Link
              to={`/competences/${toCamelCase(competence)}`}
              href={`/competences/${toCamelCase(competence)}`}
            >
              {competence}
            </Link>
          </Menu.Item>
        ))}
      </SubMenu>,

      <Menu.Item key="honoraires">
        <Link href="/honoraires" to="/honoraires">
          Honoraires
        </Link>
      </Menu.Item>,
      <Menu.Item key="contact">
        <Link href="/contact" to="/contact">
          Contact
        </Link>
      </Menu.Item>,
    ];

    const menuSider = (
      <Popover
        autoAdjustOverflow
        overlayClassName={classes.popoverMenu}
        placement="bottomLeft"
        content={
          <Menu
            className={classes.menu}
            selectedKeys={[this.state.current]}
            onClick={this.handleClick}
            mode="inline"
          >
            {menuContent}
          </Menu>
        }
        trigger="click"
        visible={menuVisible}
        arrowPointAtCenter
        onVisibleChange={this.onMenuVisibleChange}
      >
        <Button
          shape="circle"
          size="large"
          className={classes.button}
          onClick={this.handleShowMenu}
        >
          <Icon type="menu-unfold" style={{ fontSize: 24 }} />
        </Button>
      </Popover>
    );

    return (
      <Header className={classes.root}>
        <Col span={18}>
          <Row type="flex" justify="center" align="bottom">
            <Col md={10} xs={22}>
              <Link to="/" href="/" className={classes.logoLink}>
                {logo}
              </Link>
            </Col>
            <Col md={14} xs={2} id="headerMenu">
              <MenuDesktop>
                {' '}
                <Menu
                  className={classes.menu}
                  selectedKeys={[this.state.current]}
                  mode="horizontal"
                  onClick={this.handleClick}
                >
                  {menuContent}
                </Menu>
              </MenuDesktop>
              <MenuSider>{menuSider}</MenuSider>
            </Col>
          </Row>
        </Col>
      </Header>
    );
  }
}

const HeaderStyled = injectSheet(styles)(HeaderTab);

export default HeaderStyled;



// WEBPACK FOOTER //
// ./src/app/containers/header.jsx